import React from 'react';
import { Button } from 'reactstrap';

const News = (props) => {
    const adminDisplay = () =>{
        if (props.displayType === "NewsManage"){
            return(
            <tr>
                <td className="news-list-date">{props.newsDate.substring(0,10)}</td>
                <td className="news-list-content">{props.newsText}</td>
                <td className="news-list-operation">
                    <Button 
                        color="primary" size="sm"
                        style={{ marginRight:"10px"}}
                        onClick={props.editNewsInfo}
                        value={props.newsId}>編集</Button>
                    <Button 
                        color="primary" size="sm"
                        onClick={props.deleteNewsInfo}
                        value={props.newsId}>削除</Button>
                </td>
            </tr>
                )
        }else{
            return(
            <tr>
                <td className="news-list-date">{props.newsDate.substring(0,10)}</td>
                <td className="news-list-content">{props.newsText}</td>
            </tr>
            )
        }
    }

    return(
        <>{adminDisplay()}</>
    )
}


export default News;